import { Box, Typography } from "@mui/material";
import theme from "../../../../../theme";
import { BAR_TABLE_GAP, BAR_PADDING_X, BAR_PADDING_Y } from "../constants";

export const TitleBar = ({ title }) => (
  <Box
    sx={{
      mb: BAR_TABLE_GAP,
      backgroundColor: "primary.main",
      borderRadius: theme.borderRadius.small,
      px: BAR_PADDING_X,
      py: BAR_PADDING_Y,
    }}
  >
    <Typography
      variant="subtitle1"
      sx={{ color: "primary.white", fontWeight: 700 }}
    >
      {title}
    </Typography>
  </Box>
);
